interface StarCounts {
  whole: Array<number>;
  half: boolean;
  empty: Array<number>;
}

const TOTAL_STARS = 5;

const getStarCounts = (rating: number): StarCounts => {
  const safeRating = Math.max(0, Math.min(100, rating));

  const wholeCount = Math.floor(safeRating / 20);
  const remainder = safeRating % 20;
  const halfCount = remainder >= 10 ? 1 : 0;
  const emptyCount = TOTAL_STARS - wholeCount - halfCount;

  return {
    whole: Array.from({ length: wholeCount }, (_value, index) => index),
    half: halfCount > 0,
    empty: Array.from({ length: emptyCount }, (_value, index) => index),
  };
};

export default getStarCounts;
